<template>
  <v-dialog v-model="value" width="550" persistent>
    <v-form ref="form">
      <v-card class="w-100 rounded-lg">
        <v-card-title>{{ $t('spedilink.links.addToList') }}</v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="selectedListIds"
            :items="lists"
            :loading="listsLoading"
            :search-input.sync="listsSearch"
            item-value="id"
            item-text="name"
            :label="$t('spedilink.links.selectLists')"
            :placeholder="$t('spedilink.links.searchLists')"
            outlined
            dense
            multiple
            chips
            small-chips
            deletable-chips
            hide-no-data
            @update:search-input="onListsSearch"
          />
        </v-card-text>
        <v-card-actions class="d-flex justify-end px-4 pb-4">
          <v-btn outlined :disabled="loading" @click="close()">
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
            color="primary"
            class="ml-2"
            :loading="loading"
            :disabled="loading || selectedListIds.length === 0"
            depressed
            @click="save()"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import Service from '@/services'
import { GUID_EMPTY } from '@/views/Spedilink/spedilink-constants'

export default {
  name: 'AddOfferToListDialog',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    offerId: {
      type: String,
      default: null
    },
    type: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      selectedListIds: [],
      lists: [],
      listsLoading: false,
      listsSearch: '',
      listsSearchTimeout: null
    }
  },
  watch: {
    value (newVal) {
      if (newVal) {
        this.loadLists()
      } else {
        this.resetForm()
      }
    }
  },
  methods: {
    onListsSearch (val) {
      clearTimeout(this.listsSearchTimeout)
      this.listsSearchTimeout = setTimeout(() => {
        this.loadLists(val)
      }, 400)
    },
    async loadLists (search) {
      this.listsLoading = true
      try {
        const params = { type: this.type, page: 1, pageSize: 50 }
        if (search) params.search = search
        const { data } = await Service.get('spedilink/SpediLinks/GetList', params)
        this.lists = (data.results || []).filter(l => l.id !== GUID_EMPTY)
      } catch (e) {
      } finally {
        this.listsLoading = false
      }
    },
    close () {
      this.$emit('close')
      this.resetForm()
    },
    resetForm () {
      this.selectedListIds = []
      this.lists = []
      this.listsSearch = ''
    },
    async save () {
      this.loading = true
      try {
        await Service.post('spedilink/SpediLinkOffers/CopyMarketOfferToSpediLink', {
          offerId: this.offerId,
          spediLinkIds: this.selectedListIds
        })
        this.$emit('offer-added-to-list')
        this.close()
      } catch (e) {
        // Errors are handled globally by interceptor
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
